module.exports = __webpack_public_path__ + "img/modalBigJob.5c9d9267.svg";